/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectConstants } from "./Api/constantSlice";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;
}
export default function DocumentOwner({ formik }: Props) {
  const selData = useAppSelector(selectConstants);
  const mapEnums = (key: string) => {
    switch (key) {
      case "Applicant":
        return 0;
      case "Dependant":
        return 1;
      case "Guardian":
        return 2;
      default:
        return -1;
    }
  };

  return (
    <>
      {selData.constantState.documentOwners && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.documentOwnerId &&
                Boolean(formik.errors.documentOwnerId)
              }
              id="demo-select-small"
            >
             Select Document Owner
            </InputLabel>
            <Select
              name="documentOwnerId"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.documentOwnerId}
              label="Select Document Owner"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.documentOwnerId &&
                Boolean(formik.errors.documentOwnerId)
              }
            >
              <MenuItem value={-1} disabled>
              Select Document Owner
              </MenuItem>
              {selData.constantState.documentOwners.map(
                (item: string, key: number) => {
                  return (
                    <MenuItem key={key} value={mapEnums(item)}>
                      {item.replace(/([A-Z])/g, " $1").trim()}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>


          <ErrorBox>
          {formik.touched.documentOwnerId &&
              (formik.errors.documentOwnerId as React.ReactNode)}
                              </ErrorBox>


        </>
      )}
    </>
  );
}
